export default "__VITE_ASSET__AwZ9$NYy__"